import { AdminGlobalStore } from '../../store/admin-global.store';
import { AdminSiteFooterComponent } from '../admin-site-footer/admin-site-footer.component';
import { AdminSiteHeaderComponent } from '../admin-site-header/admin-site-header.component';

import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CountBadgeComponent, NonProdBannerComponent } from '@web/csl-lib-components';
import { DrawerModule } from 'primeng/drawer';
import { environment } from '../../../environments/environment';
import { GlobalStore } from '@web/csl-lib-store';
import { FeatureFlagService, HelpService } from '@web/csl-lib-services';
import { MessageService } from 'primeng/api';
import { PassportForCareConstants } from '@web/csl-lib-constants';
import { ProgressBar } from 'primeng/progressbar';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-admin-home-layout',
  standalone: true,
  imports: [
    AdminSiteFooterComponent,
    AdminSiteHeaderComponent,
    CountBadgeComponent,
    DrawerModule,
    ProgressBar,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    ToastModule,
    NonProdBannerComponent
],
  templateUrl: './admin-home-layout.component.html',
  styleUrl: './admin-home-layout.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [GlobalStore, MessageService],
})
export class AdminHomeLayoutComponent {
  /* Store */

  readonly globalStore = inject(GlobalStore);
  readonly adminGlobalStore = inject(AdminGlobalStore);

  /* Services */
  readonly helpService = inject(HelpService);
  readonly featureFlagService = inject(FeatureFlagService);

  /* Member Vars */
  showHelp = computed(() => this.helpService.helpContent() !== null);

  /* Lifecycle Hooks */

  /* Event Handlers */

  onHelpDrawerHide() {
    this.helpService.clearHelp();
  }

  /* Instance Methods */
  protected readonly environment = environment;
  pfcLogoUrl = PassportForCareConstants.LOGO_SYMBOL_URL;
}
